import * as React from "react";
function SvgIcChevronDoubleLeft(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.067 5l.65.375-3.851 6.669 3.851 6.668-.65.375L8 12.044 12.067 5z"
        fill="currentColor"
      />
      <path
        d="M16.067 5l.65.375-3.851 6.669 3.851 6.668-.65.375L12 12.044 16.067 5z"
        fill="currentColor"
      />
    </svg>
  );
}
export default SvgIcChevronDoubleLeft;
